module.exports = __webpack_public_path__ + "img/call-center-agent.eb5ac6af.png";